<style>
.v-label,
.v-select__selections {
  font-size: 12px !important;
}
</style>

<template>
  <div
    style="height: 85%"
    class="TerminalsTable"
  >
    <ExportTableData
      ref="pobierz"
      :column-defs="columnDefs"
      :grid-options="gridOptions"
    ></ExportTableData>
    <v-layout>
      <v-flex xs7>
        <v-layout
          class="table--first-row button-functon"
          row
          wrap
          :class="{rowHide: !selectedRow}"
        >
          <v-flex class="table__wrapper--center">
            <v-icon
              class="table__btn--blue table__btn--padding"
              v-show="selectedRow"
              @click="openTerminalCard"
            >note</v-icon>
            <p
              class="caption"
              v-show="selectedRow"
              @click="openTerminalCard"
            >OTWÓRZ KARTĘ</p>
            <v-icon
              class="table__btn--red table__btn--padding"
              v-show="selectedRow"
              @click="removeRow"
              style="margin-left: 12px"
            >delete</v-icon>
            <p
              class="caption"
              v-show="selectedRow"
              @click="removeRow"
            >USUŃ</p>
          </v-flex>
          <v-spacer />
        </v-layout>
        <v-layout
          class="button-functon"
          row
          wrap
        >
          <v-flex class="table__wrapper--center">
            <v-icon
              @click="'pobierz' in $refs && $refs.pobierz.showExportMenu($event)"
              class="table__btn--blue table__btn--padding "
            >cloud_download</v-icon>
            <p
              class="caption"
              @click="'pobierz' in $refs && $refs.pobierz.showExportMenu($event)"
            >POBIERZ REJESTR</p>
            <v-icon
              class="table__btn--padding"
              v-show="selectedRow"
              @click="zoomToGeometry"
            >zoom_in</v-icon>
            <p
              class="caption"
              v-show="selectedRow"
              @click="zoomToGeometry"
            >PRZYBLIŻ</p>
            <template v-if="numberAll == numberFiltered">
              <v-icon
                class="table__btn--padding"
                @click="findTerminalsUnconnected(false)"
              >search</v-icon>
              <p
                class="caption"
                @click="findTerminalsUnconnected(false)"
              >Wyszukanie przyłączy</p>
            </template>
            <template v-else>
              <v-icon
                class="table__btn--red table__btn--padding"
                @click="findTerminalsUnconnected(true)"
              >clear</v-icon>
              <p
                class="caption"
                @click="findTerminalsUnconnected(true)"
              >Wyszukanie przyłączy</p>
            </template>

          </v-flex>
          <v-spacer />
        </v-layout>
      </v-flex>
      <v-flex
        xs5
        class="table__wrapper--center table__wrapper--filter"
      >
        <v-layout
          align-right
          justify-end
        >
          <v-select
            :items="statuses"
            label="Filtr: status"
            v-model="filterStatus"
            hide-details
            clearable
            @change="filterByStatus(filterStatus)"
            style="padding-right:10px;"
          ></v-select>
          <v-text-field
            type="text"
            v-model="filter"
            placeholder="Treść filtra"
            clearable
            :hint="numberFiltered + '/' + numberAll"
            persistent-hint
            filled
          >
          </v-text-field>
        </v-layout>
      </v-flex>
    </v-layout>
    <ag-grid-vue
      style="width: 100%; height: 85%;"
      class="ag-theme-balham"
      :gridOptions="gridOptions"
    ></ag-grid-vue>
  </div>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import GeoJSON from "ol/format/GeoJSON.js";
import ExportTableData from "../../shared/ExportTableData";

import chain from "lodash/chain";
import value from "lodash/value";
import mixin from "lodash/mixin";
import _ from "lodash/wrapperLodash";
import filter from "lodash/filter";
import includes from "lodash/includes";
mixin(_, {
  chain,
  filter,
  includes,
});
_.value = value;
_.prototype.value = value;

export default {
  name: "App",
  data: () => ({
    tableTitle: "terminalsTable",
    filter: "",
    filterStatus: "",
    inspectionsTaskFiltered: undefined,
    numberAll: 0,
    numberFiltered: 0,
    selectedRow: undefined,
    statuses: []
  }),
  components: {
    AgGridVue,
    ExportTableData
  },
  watch: {
    filter(nV) {
      this.gridOptions.api.setQuickFilter(nV);
      this.numberFiltered = this.gridOptions.api.getModel().getRowCount();
    }
  },
  computed: {
    gridOptions() {
      let gridOptions = {
        rowData: this.loadData(),
        overlayLoadingTemplate:
          '<span class="ag-overlay-loading-center">Trwa ładowanie danych</span>',
        columnDefs: this.columnDefs,
        enableSorting: "true",
        enableFilter: "true",
        enableColResize: "true",
        onGridReady: this.onGridReady,
        onColumnMoved: this.onColumnMoved,
        onColumnResized: this.onColumnMoved,
        onSelectionChanged: this.onSelectionChanged,
        rowSelection: "single",
        onFilterChanged: this.filteredNumber,
        context: {
          componentParent: this
        },
        localeText: {
          contains: "Zawiera",
          notContains: "Nie zawiera",
          equals: "Równa się",
          notEqual: "Nie równa się",
          startsWith: "Zaczyna się",
          endsWith: "Kończy się",
          noRowsToShow: "Brak danych"
        }
      };
      return gridOptions;
    },
    terminals() {
      return this.$store.getters.getTerminals;
    },
    terminalData() {
      return this.$store.getters.getTerminalData;
    },
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    srid() {
      return this.$store.getters.getSrid;
    }
  },
  methods: {
    nullValue(params) {
      if(!params.value) {
        params.value = "Brak wartości";
        return params.value;
      } else {
        return params.value;
      }
    },
    openTerminalCard() {
      let payload = {
        object_id: this.selectedRow.id,
        object_table: "terminals",
        object_type: "layers"
      };

      this.$store.dispatch("getFeature", payload).then(success => {
        if(success) {
          this.$store.commit("setTerminalData", success);
          this.$nextTick(() => {
            this.show("terminalCardModal");
          })
          this.$root.$emit('loadTerminalCard', this.selectedRow)
        } else {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Podczas pobierania danych przyłącza wystąpił błąd"
          );
        }
      });
    },
    removeRow() {
      console.log('ogórek')
    },
    zoomToGeometry() {
      console.log(this.selectedRow)
      this.$root.$emit("zoomToFeature", this.selectedRow, {
        srid: this.srid
      });
    },
    onSelectionChanged() {
      this.selectedRow = this.gridOptions.api.getSelectedRows()[0];
    },
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    loadData() {
      this.$store
        .dispatch("getFeatures", {layername: "terminals", srid: this.$store.getters.getSrid})
        .then(success => {
          if(success) {
            this.$store.commit("setTerminals", success);
            this.numberAll = this.terminals.features.length;
            this.numberFiltered = this.numberAll;
            this.gridOptions.api.setRowData(this.terminals.features);
            this.gridOptions.api.setColumnDefs(this.columnDefs);
          }
        });

      let payload = {
        schema: "aquagis",
        table: "terminals",
        column: "status"
      }
      this.$store.dispatch('getDictSTC', payload).then(r => {
        this.statuses = r.values;
      })
    },
    onColumnMoved(params) {
      const columnState = JSON.stringify(
        this.gridOptions.columnApi.getColumnState()
      );
      localStorage[this.tableTitle] = columnState;
    },
    onGridReady(params) {
      if(localStorage[this.tableTitle]) {
        const columnState = JSON.parse(localStorage[this.tableTitle]);
        if(columnState) {
          this.gridOptions.columnApi.setColumnState(columnState);
        }
      }
    },
    filterByStatus(value) {
      let statusFilter = this.gridOptions.api.getFilterInstance(
        "properties.status"
      );
      statusFilter.setModel({
        type: "equals",
        filter: value
      });
      this.gridOptions.api.onFilterChanged();
      this.filteredNumber();
    },
    filteredNumber() {
      this.numberFiltered = this.gridOptions.api.getModel().getRowCount();
    },
    findTerminalsUnconnected(type = false) {
      const self = this;
      const api = self.gridOptions.api;

      self.filter = "";

      if(type) {
        self.numberFiltered = self.numberAll;
        api.setRowData(this.terminals.features);
        return;
      }

      return fetch(
        `${self.$store.getters.getApiURL}/terminals/unconnected?token=${self.$store.getters.getToken}`
      )
        .then(r => r.json())
        .then(data => data.terminals)
        .catch(() => [])
        .then((ids) => {
          self.numberFiltered = ids.length;
          api.setRowData(_.filter(self.terminals.features, feature => _.includes(ids, +feature.id)));
        });
    },
  },
  beforeMount() {
    this.columnDefs = [{
      headerName: "ID przyłącza",
      field: "id",
      sort: "asc",
      filter: 'number',
    }];
    this.$store.dispatch('getLayer', 'terminals').then(r => {
      if(r) {
        r.fields.forEach(field => {
          if(field.name !== "id") {
            let property = {
              headerName: field.display_name,
              field: "properties." + field.name,
              valueFormatter: this.nullValue
            };
            this.columnDefs.push(property);
          }
        });
      }
    })

  },
  mounted() {
    this.$root.$on("edited_terminal", this.loadData);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/table/TerminalsTable.vue